import { useWebApp } from "vue-tg"
import store from "@/store"
import { BotConfig } from "./botConfig"

export class UserManager {
  static getTelegramUserData() {
    const tg = useWebApp()
    const initData = tg?.initDataUnsafe

    if (initData?.user) {
      return {
        id: initData.user.id,
        first_name: initData.user.first_name,
        last_name: initData.user.last_name || "",
        username: initData.user.username || `user_${initData.user.id}`,
        language_code: initData.user.language_code || "ru",
        is_premium: initData.user.is_premium || false,
        photo_url: initData.user.photo_url || null,
      }
    }

    return null
  }

  static getUserData() {
    return store.getters.getTgUserData || this.getTelegramUserData()
  }

  static getBotId() {
    return BotConfig.getBotId() || store.getters.getBotId
  }

  static getFullUserContext() {
    const userData = this.getUserData()
    const botId = this.getBotId()

    return {
      user: userData,
      botId: botId,
    }
  }
}
